import { useCartContext } from "@/src/context/CartContext";
import { PageHero } from "@/src/components/PageHero";
import { CollectionGrid } from "@/src/pages/collection/(sections)/CollectionGrid";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function AccessoriesPage() {
    const { addToCart } = useCartContext();

    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1571066811602-716837d681de?auto=format&fit=crop&q=80&w=2000"
                label="Complete the ritual"
                title="Accessories"
            />
            <CollectionGrid onAddToCart={addToCart} />
            <Newsletter />
        </>
    );
}
